export default __webpack_public_path__ + "static/media/gama_banner_Camiones_Furgones-1024x425.8285ea3b.webp";